<template>
    <v-tooltip top open-delay='700'>
      <template v-slot:activator='{ on }'>
        <v-chip
          class='mx-2'
          v-on='on'
          label
          small
          :color="amount > 0 ? 'error' : 'grey darken-4'"
          dark
        >
          {{name}}: {{ amount }}
        </v-chip>
      </template>
    </v-tooltip>
  </template>
  
  <script>
  export default {
    name: 'attempted-wos',
    props: {
        name: {
            type: String,
            required: true
        },
        amount: {
            type: Number,
            required: true
        }
    }
  }
  
  </script>
  